document.addEventListener("alpine:init", () => {
  Alpine.data("bfGiftSubscribe", () => ({
    loading: false,
    email: "",
    errMsg: "",
    checked: false,
    isSuccess: false,

    getMessages() {
      const s = bfbannerSettingJsons || {};
      return {
        disclaimerError:
          s.disclaimer_error_message ||
          "Please tick agreement boxes to proceed.",
        emailError:
          s.email_error_message || "Email: invalid format!",
        apiError:
          s.api_error_message ||
          "Oops... Something went wrong, please refresh and try again.",
      };
    },

    clearMessages() {
      this.errMsg = "";
      this.isSuccess = false;
    },

    async submitResult() {
      const msg = this.getMessages();

      if (!this.checked) {
        this.errMsg = msg.disclaimerError;
        return;
      }
      const isEmailValid = validateEmail(this.email);
      if (!isEmailValid) {
        this.errMsg = msg.emailError;
        return;
      }
      this.errMsg = "";

      const fieldsArray = createFieldsArray(bfbannerSettingJsons);
      const contactListId = getContactListId(bfbannerSettingJsons);

      const { apiUrl, acceptedLanguage, apiKey, xAppid } =
        theme.emailSubscription;

      const subscribeInfoCookie = window.getCookieForEmarsys("subscribe_info");
      let eventTracking = null;

      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie);
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts;
        } catch (error) {
          console.warn("Failed to parse subscribe_info cookie:", error);
        }
      }

      const apiBody = {
        email: this.email,
        contactListId,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };

      this.loading = true;
      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
            traceId: traceId,
            "X-appid": xAppid,
            "Accepted-Language": acceptedLanguage,
          },
          body: JSON.stringify(apiBody),
        });

        const data = await response.json();

        if (data.message === "Success") {
          this.isSuccess = true;
          this.email = "";
        }else {
          this.errMsg = msg.apiError;
        }
      } catch (error) {
        this.errMsg = msg.apiError;
      } finally {
        this.loading = false;
      }
    },
  }));
});
